<template>
  <div>
    <van-sidebar-item
      :data-level="level"
      :title="menu.name"
      :class="{ 'van-sidebar-item--select': isActive }"
      @click="handleClick"
    />
    <transition-group name="slide-fade">
      <SidebarItem
        v-for="(child, index) in visibleChildren"
        :key="child.id"
        :menu="child"
        :level="level + 1"
        :active-id="activeId"
        @toggleChildren="toggleChildren"
      />
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "SidebarItem",
  props: {
    menu: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
    activeId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isExpanded: true, // 是否展开子菜单
    };
  },
  computed: {
    /**
     * 计算可见的子菜单
     */
    visibleChildren() {
      return this.isExpanded ? this.menu.children || [] : [];
    },
    // 判断当前菜单项是否激活
    isActive() {
      // 当activeId为null或空字符串时，ID为0的"全部"菜单项应该高亮
      if ((this.activeId == null || this.activeId === "") && this.menu.id === 0) {
        return true;
      }
      // 确保类型一致后再比较
      if (this.activeId == null || this.menu.id == null) {
        return false;
      }
      // 转换为字符串进行比较，避免类型问题
      return String(this.activeId) === String(this.menu.id);
    },
    itemColor() {
      if (this.level === 0 && this.isActive) {
        return "#4c9673"; // 一级菜单被选中时的背景色
      } else if (this.level === 1) {
        return this.isActive ? "#5ca884" : "#a9cbc2"; // 二级菜单被选中时的背景色
      } else if (this.level >= 2) {
        return "#a9cbc2"; // 子菜单展开时的背景色
      } else return "#efefef";
    },
  },
  methods: {
    handleClick() {
      this.toggleChildren(this.menu.id);
    },
    toggleChildren(id) {
      this.$emit("toggleChildren", id);
    },
  },
};
</script>

<style lang="less" scoped>
@main-color: #4c9673;
@level1-color: #5ca884;
@level2-color: #6dbd95;
@child-color: #a9cbc2;
.van-sidebar-item {
  padding-left: 10px;
  font-size: 14px;
  font-weight: bold;
  background-color: #efefef;
  text-align: center;
  color: #333;
  padding-top: 13px;
  padding-bottom: 13px;

  &[data-level="0"] {
    font-size: 14px;
    font-weight: bold;
    padding-left: 5px;
  }

  &[data-level="1"] {
    font-size: 14px;
    font-weight: normal;
    padding-left: 10px;
  }

  &[data-level="2"] {
    font-size: 14px;
    font-weight: normal;
    padding-left: 15px;
  }
}

/* 提高样式优先级，确保自定义样式覆盖组件默认样式 */
:deep(.van-sidebar-item--select) {
  color: #fff !important;
  background-color: @main-color !important;

  &[data-level="0"] {
    background-color: @main-color !important;
    border-radius: 0px 10px 0px 10px !important;
  }

  &[data-level="1"] {
    background-color: @level1-color !important;
  }

  &[data-level="2"] {
    background-color: @level2-color !important;
  }
  .loop-levels(@counter) when (@counter <= 11) {
    &[data-level="@{counter}"] {
      background-color: @level2-color !important;
    }
    .loop-levels(@counter + 1);
  }
  .loop-levels(2);
  + span {
    .van-sidebar-item {
      background-color: @child-color;
    }
  }
}
/* 完全移除默认的伪元素样式 */
:deep(.van-sidebar-item--select::before) {
  display: none !important;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
